import { FC, PropsWithChildren } from 'react';

import { Box, Card, Heading, Skeleton, VisuallyHidden } from '@eneco/sparky';

interface Props {
  label?: string;
  height?: number;
  singleSkeleton?: boolean;
}

const headingHeight = 30;

export const StretchBucketSkeleton: FC<PropsWithChildren<Props>> = ({
  label,
  height = 200,
  children,
  singleSkeleton,
}) => {
  return (
    <Card>
      <Box padding="6">
        <VisuallyHidden>
          <Heading as="h3">{label || fallbackText}</Heading>
          {children}
        </VisuallyHidden>
        {singleSkeleton ? (
          <Skeleton width="100%" height={height} />
        ) : (
          <>
            <Skeleton height={headingHeight} />
            <Skeleton height={height - headingHeight} />
          </>
        )}
      </Box>
    </Card>
  );
};

export const fallbackText = 'Bezig met laden...';
